import { Box } from 'src/design/atoms/Box';
import { LoadingOverlay } from 'src/design/atoms/LoadingOverlay';
import React from 'react';
import { TimesheetDto } from 'src/api/FiretrolApiClient';
import { useParams } from 'react-router-dom';
import { useDaily } from 'src/api/queries/dailys/useDaily';
import { useTimesheetsForJob } from 'src/api/queries/timesheets/useTimesheetsForJob';
import { useJobs } from 'src/hooks/useJobs';
import { Header } from 'src/design/organisms/Header';
import { getWorkWeek } from 'src/utils/workWeek';
import { DailyForm } from 'src/routes/Jobs/Dailys/DailyForm';

const EMPTY_TIMESHEETS: TimesheetDto[] = [];

export const ViewDaily: React.FC = () => {
  const { selectedJob } = useJobs();
  const params: any = useParams();
  const { data: daily, isLoading } = useDaily(params.dailyId);

  const week = daily?.date ? getWorkWeek(daily.date) : null;
  const { data: timesheets = EMPTY_TIMESHEETS } = useTimesheetsForJob(
    selectedJob?.id,
    { weekId: week?.weekNumber, year: week?.year, dailyContext: true },
    { enabled: !!week },
  );

  const values = React.useMemo(
    () =>
      daily
        ? {
            ...daily,
            progressItemRequests: daily.dailyProgressItem.map((item) => item),
          }
        : null,
    [daily],
  );

  if (!selectedJob) return null;

  return (
    <>
      <Header
        title={values?.dailyNumber || 'Daily Report'}
        breadcrumbProps={{
          items: [
            { text: 'Jobs', href: '/jobs' },
            {
              text: `${selectedJob?.name} - ${selectedJob?.jobNumber}`,
              href: `/jobs/${selectedJob?.id}/summary`,
            },
            { text: 'Dailys', href: `/jobs/${selectedJob?.id}/dailys` },
            { text: values?.dailyNumber || 'Daily Report' },
          ],
        }}
        helpText="View daily report details"
      />

      <Box pos="relative" mt="md">
        <LoadingOverlay visible={isLoading} />

        {!isLoading && values && (
          <DailyForm
            initialValues={values}
            dailyId={params.dailyId}
            timesheets={timesheets}
          />
        )}
      </Box>
    </>
  );
};
